<ms-split-navigation-panel [title]="settingsPanelTitle" [navItems]="settingsNavItems()"
    [initialTabId]="initialSubtab()"
    (tabChanged)="onSettingsTabChanged($event)">

    <ng-template msNavContent="general">
        @if (organization()) {
        <ms-organization-general-settings [organization]="organization()!"
            (organizationSettingsUpdated)="onGeneralSettingsUpdated($event)"
            (organizationUpdated)="onOrganizationUpdated($event)">
        </ms-organization-general-settings>
        }
    </ng-template>

    <ng-template msNavContent="stripe-onboarding">
        @if (organization() && organizationSettings()) {
        <ms-stripe-organization-onboarding [organization]="organization()!" [organizationSettings]="organizationSettings()!"
            (onboardingComplete)="onStripeOnboardingComplete($event)" (onboardingExit)="onStripeOnboardingExit()">
        </ms-stripe-organization-onboarding>
        }
    </ng-template>

    <ng-template msNavContent="transfer-ownership">
        @if (organization()) {
        <ms-transfer-organization-ownership [organization]="organization()!">
        </ms-transfer-organization-ownership>
        }
    </ng-template>

    <ng-template msNavContent="manage-organization-admins">
        @if (organization()) {
        <ms-manage-organization-admins [organization]="organization()!">
        </ms-manage-organization-admins>
        }
    </ng-template>

    <ng-template msNavContent="message-suppression">
        @if (organization()) {
        <ms-organization-message-suppression-settings [organization]="organization()!"
            (suppressionUpdated)="onSuppressionUpdated($event)">
        </ms-organization-message-suppression-settings>
        }
    </ng-template>

</ms-split-navigation-panel>